import Logo from 'assets/svg/apertum-logo.svg'
import * as H from 'history'
import React from 'react'
import { match, NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { useActiveWeb3React } from '../../hooks'
import Row, { RowFixed } from '../Row'
import MainMenu from 'components/Header/MainMenu'
import Web3Status2 from 'components/Web3Status/Web3Status2'
import { MEDIA_WIDTHS } from '../../theme'

const HeaderFrame = styled.div`
  width: 100%;
  position: relative;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);

  background-image: linear-gradient(to bottom, #11314a, #0c2539);

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        // padding: 0.5rem 1rem;
  `}
`
const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  margin: 0 auto;

  padding: 0 1.9rem;
  height: 100px;

  max-width: ${MEDIA_WIDTHS.upToLarge}px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
      height: 60px;
    grid-template-columns: 1fr;
    padding: 0 1rem;
  `};
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    width: 100%;
    max-width: 960px;
    padding: 1rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 2;
    border-radius: 12px 12px 0 0;
   background-image: linear-gradient(to bottom, #11314a, #0c2539);
    border-top: solid 1px #224765;
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  /* addresses safari's lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

const HeaderRow = styled(RowFixed)`
  height: 100%;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
 `};
  ${({ theme }) => theme.mediaWidth.upToMedium`
   width: 100%;
   height: 100%;
  `};
`

const HeaderLinks = styled(Row)`
  height: 100%;
  padding-left: 18px;
  padding-right: 18px;
  overflow: hidden;
  gap: 24px;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: flex-end;
`};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  // background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)};
  // border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
`

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const HideBig = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: block;
  `};
  display: none;
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({ activeClassName })`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: #76b0de;
  font-size: 16px;
  width: fit-content;
  font-weight: 500;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.3s ease;

  &.${activeClassName} {
    border-radius: 0;
    font-weight: 600;
    color: #fff;
    :before {
      content: '';
      position: absolute;
      left: -12.5%;
      bottom: 0;
      display: block;
      height: 2px;
      width: 125%;
      background-color: #5cb6c8;
    }
  }

   &.${activeClassName} {
    :after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      display: block;
      height: 0.5rem;
      border-radius: 100%;
      background-color: #5cb6c8;
      background-position: 50%;
      // opacity: .8;
      --tw-blur: blur(10px);
      filter: var(--tw-blur);
    }
  }
  :hover,
  :focus {
    color: #fff;
  }
`

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

export const BtnDarkMode = styled.button`
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  border: solid 1px ${({ theme }) => theme.bg4};
  background-color: transparent;
  margin: 0;
  padding: 0;
  background-color: ${({ theme }) => theme.bg1};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

export const NavButton = styled.div`
  display: flex;
  gap: 13.5px;
  height: 59px;
  padding: 11.5px 16.5px 11.5px 12px;
  border-radius: 5px;
  border: solid 1px #224765;
  background-image: linear-gradient(to bottom, #11314a, #0c2539);
  white-space: nowrap;
  cursor: pointer;
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-color: rgb(50 50 127);
  }
`
export const NavButtonText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.07px;
  color: #fff;
  margin-bottom: 2px;
  text-decoration: none;
`
export const NavButtonLink = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #a2a4ec;
  text-decoration: none;
`

export const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 18px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

export const UniIcon = styled.div`
  transition: transform 0.3s ease;
  // :hover {
  //   transform: rotate(-5deg);
  // }
`

export default function Header() {
  const { account } = useActiveWeb3React()

  const navLinks = [
    {
      id: 'swap-nav-link',
      name: 'Swap',
      href: '/swap',
      isActive: undefined // No custom `isActive` logic for this link
    },
    // {
    //   id: 'tokens-nav-link',
    //   name: 'Tokens',
    //   href: '/tokens',
    //   isActive: (match: match | null, { pathname }: H.Location) =>
    //     Boolean(match) || pathname.startsWith('/tokens') || pathname.startsWith('/token')
    // },
    {
      id: 'pool-nav-link',
      name: 'Pools',
      href: '/pool',
      isActive: (match: match | null, { pathname }: H.Location) =>
        Boolean(match) ||
        pathname.startsWith('/add') ||
        pathname.startsWith('/remove') ||
        pathname.startsWith('/create') ||
        pathname.startsWith('/find')
    },
    {
      id: 'tokens-nav-link',
      name: 'Tokens',
      href: '/tokens',
      isActive: (match: match | null, { pathname }: H.Location) => Boolean(match) || pathname.startsWith('/token/')
    },
    {
      id: 'faq-nav-link',
      name: 'FAQ',
      href: '/faq',
      isActive: (match: match | null) => Boolean(match)
    }
  ]

  return (
    <>
      <HeaderFrame>
        <HeaderContainer>
          {/* LEFT MENU ITEMS */}
          <HeaderRow>
            <Title href=".">
              <UniIcon>
                <img height={'36px'} src={Logo} alt="logo" />
              </UniIcon>
            </Title>

            {/* MENU ITEMS */}
            <HideSmall style={{ height: '100%' }}>
              <HeaderLinks>
                {navLinks.map(link => (
                  <StyledNavLink key={link.id} id={link.id} to={link.href} isActive={link.isActive}>
                    <div style={{ padding: '0 16px'}}>{link.name}</div>
                  </StyledNavLink>
                ))}
              </HeaderLinks>
            </HideSmall>

            <HideBig>
              <MainMenu navLinks={navLinks} />
            </HideBig>
          </HeaderRow>

          <HeaderControls>
            <HeaderElement>
              {/* <HideSmall>
                <NetworkTag>
                  {chainId && NETWORK_LABELS[chainId] && (
                    <>{NETWORK_LABELS[chainId]}</>
                  )}
                </NetworkTag>
              </HideSmall> */}

              <AccountElement active={!!account} style={{ pointerEvents: 'auto', marginLeft: '0px' }}>
                <Web3Status2 />
              </AccountElement>
            </HeaderElement>
          </HeaderControls>
        </HeaderContainer>
      </HeaderFrame>
    </>
  )
}
